import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';



import IMask from 'imask';

window.Swiper = Swiper;



document.addEventListener('DOMContentLoaded', function(){

  const swiperContainer = document.querySelector('.promo');
  
    if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 3,
            spaceBetween: 30,
            speed: 400,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
                           breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
        
    },
      768: {
      slidesPerView: 3,
    },
  },
        });




    } 



 
 
  





function debounce(func, wait, immediate = false) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}


// FILTER
// FILTER
// FILTER
// FILTER
// FILTER
let currentFilters = {};
let currentSort = {
  type: null,
  direction: null
};
  const commonForm = document.querySelector('.common-sort');

if (commonForm) {
  document.addEventListener('click', (e) => {



    if (e.target.closest('.page-link')) {
        e.preventDefault();
        const page = e.target.closest('.page-link').dataset.page;
        debouncedLoadCars(page);
    }
});
}



const debouncedLoadCars = debounce(loadCars, 300);

async function loadCars(page = 1) {
    const loader = document.querySelector('.loading');
    if (loader) loader.style.display = 'flex';
    

   if (commonForm) {
           const formData = new FormData(commonForm);
          currentFilters = Object.fromEntries(formData.entries());
      }

    try {
        // 1. Создаем объект с данными запроса
        const requestData = {
            ...currentFilters,
            page: page
        };
        
        // 2. Добавляем параметры сортировки, если они есть
        if (currentSort && currentSort.type) {
            requestData.sort = {
                type: currentSort.type,
                direction: currentSort.direction
            };
        }
        
        // 3. Отправляем запрос
        const response = await fetch('/api/cars/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestData) // Используем requestData здесь
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.total == 0) {
         document.getElementById('cars-list').innerHTML =   `
                <div class="alert alert-info">
                  По заданным параметрам ничего не найдено
                </div>
            `;
            document.querySelector('.pagination-container').innerHTML = '';
            return;
        }
      
 document.getElementById('cars-list').innerHTML = data.html;
      
       
        document.querySelector('.pagination-container').innerHTML = data.pagination_html;
         onAjaxSuccess();
    } catch (error) {
        console.error('Error loading cars:', error);
        // Можно добавить отображение ошибки пользователю
    } finally {
        if (loader) loader.style.display = 'none';

    }
}






  





const filterSort = document.querySelector('.filter-sort');

if (filterSort) {
   const els = filterSort.querySelectorAll('.item');
  els.forEach((ctx) => {
    ctx.addEventListener('click', debounce(() => {
      els.forEach(el => el.classList.remove('active'));
      
      const type = ctx.getAttribute('data-type');
      const sort = ctx.getAttribute('data-sort');
      
      ctx.classList.add('active');
      currentSort = { type, direction: sort };
      
      // Инверсия для следующего клика
      ctx.setAttribute('data-sort', sort === 'asc' ? 'desc' : 'asc');
    
   
      
      debouncedLoadCars(1);
    }, 300));
  });
}
function clearSort() {
    if (filterSort) {
      currentSort = {
  type: null,
  direction: null
};
         const els = filterSort.querySelectorAll('.item');
          els.forEach((ctx) => {
               els.forEach(el => el.classList.remove('active'));
  
  }); 
    }
}


function animateCounter(element) {
    if (element) {
      element.style.transform = 'scale(1.2)';
      setTimeout(() => {
        element.style.transform = 'scale(1)';
      }, 300);
    }
  }
  // Обновление счетчиков в хедере
  function updateHeaderCounters() {
      const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  const compares = JSON.parse(localStorage.getItem('compares')) || [];
    const favoriteCounter = document.querySelector('.count-favorite span');
    const compareCounter = document.querySelector('.count-compare span');
    
    if (favoriteCounter) {
      if (favorites.length == 0) {
      
          favoriteCounter.style.display = 'none';
      }
      else {
          favoriteCounter.style.display = 'flex';
      }
   
      favoriteCounter.textContent = favorites.length;

  
    }
    
    if (compareCounter) {
        if (compares.length == 0) {
        compareCounter.style.display = 'none';
      }
      else {
        compareCounter.style.display = 'flex';
      }
      compareCounter.textContent = compares.length;
    }
    
    animateCounter(favoriteCounter);
    animateCounter(compareCounter);
  }

  // Обновление иконок в хедере
  function updateHeaderIcons() {
          const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  const compares = JSON.parse(localStorage.getItem('compares')) || [];
    const favoriteHeaderIcon = document.querySelector('.count-favorite svg');
    const compareHeaderIcon = document.querySelector('.count-compare svg');
    
    if (favoriteHeaderIcon) {
      favoriteHeaderIcon.setAttribute('fill', favorites.length > 0 ? '#fb7878' : '#999');
    }
    
    if (compareHeaderIcon) {
      compareHeaderIcon.setAttribute('fill', compares.length > 0 ? '#08c2a9' : '#999');
    }
  }


// });

// Выносим общую логику в отдельные функции
function initFavoritesAndCompare() {
  const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  const compares = JSON.parse(localStorage.getItem('compares')) || [];

  // Используем делегирование событий для динамического контента
  document.addEventListener('click', function(e) {
    // Обработка избранного
 
    if (e.target.closest('.favorite')) {
   
      const iconGroup = e.target.closest('.icons');
      const carId = iconGroup.dataset.id;
      toggleFavorite(carId, favorites);
      updateAll(favorites, compares);
    }
    
    // Обработка сравнения
    if (e.target.closest('.compare')) {
      const iconGroup = e.target.closest('.icons');
      const carId = iconGroup.dataset.id;
      toggleCompare(carId, compares);
      updateAll(favorites, compares);
    }
  });
  
  // Инициализация при загрузке
  updateAll(favorites, compares);
}

function toggleFavorite(carId, favorites) {
  const index = favorites.indexOf(carId);
  if (index === -1) {
    favorites.push(carId);
  } else {
    favorites.splice(index, 1);
  }
  localStorage.setItem('favorites', JSON.stringify(favorites));
}

function toggleCompare(carId, compares) {
  const index = compares.indexOf(carId);
  if (index === -1) {
 
    compares.push(carId);
  } else {
    compares.splice(index, 1);
  }
  localStorage.setItem('compares', JSON.stringify(compares));
  return true;
}

function updateAll(favorites, compares) {
  updateItemIcons(favorites, compares);
  updateHeaderCounters(favorites, compares);
  updateHeaderIcons(favorites, compares);
}

function updateItemIcons(favorites, compares) {
  document.querySelectorAll('.icons').forEach(iconGroup => {
    const carId = iconGroup.dataset.id;
    const isFavorite = favorites.includes(carId);
    const isCompare = compares.includes(carId);
    
    // Иконка избранного
    const favoriteBtn = iconGroup.querySelector('.favorite');
    if (favoriteBtn) {
      favoriteBtn.innerHTML = isFavorite ?
        `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fb7878" class="bi bi-heart-fill" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
        </svg>` :
        `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#253238" class="bi bi-heart" viewBox="0 0 16 16">
          <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"/>
        </svg>`;
    }
    
    // Иконка сравнения
    const compareBtn = iconGroup.querySelector('.compare');
    if (compareBtn) {
      compareBtn.innerHTML = isCompare ?
        `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#08c2a9" class="bi bi-bar-chart-fill" viewBox="0 0 16 16">
          <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"/>
        </svg>` :
        `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#253238" class="bi bi-bar-chart" viewBox="0 0 16 16">
          <path d="M4 11H2v3h2zm5-4H7v7h2zm5-5v12h-2V2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z"/>
        </svg>`;
    }
  });
}

// Остальные функции (updateHeaderCounters, updateHeaderIcons, animateCounter) остаются без изменений

// Инициализация при загрузке


// Для AJAX: вызывайте эту функцию после успешной загрузки контента





  const shareItems = document.querySelectorAll('.share-item');
  
  if (shareItems) {
    
// Используем делегирование событий
document.addEventListener('click', function(e) {
  // Открытие/закрытие меню
  if (e.target.closest('.share')) {
    e.preventDefault();
    e.stopPropagation();
    
    const shareButton = e.target.closest('.share');
    const socialIcons = shareButton.querySelector('.social-icons');
    
    // Закрываем все другие меню
    document.querySelectorAll('.social-icons').forEach(menu => {
      if (menu !== socialIcons) menu.classList.remove('active');
    });
    
    // Переключаем текущее меню
    socialIcons.classList.toggle('active');
  }
  
  // Закрытие при клике вне
  else if (!e.target.closest('.social-icons')) {
    document.querySelectorAll('.social-icons').forEach(menu => {
      menu.classList.remove('active');
    });
  }
  
  // Обработка кнопок шаринга
  if (e.target.closest('.share-item')) {
    const item = e.target.closest('.share-item');
    const socialNetwork = item.dataset.social;
    const parent = item.closest('.item');
    const title = encodeURIComponent(parent.querySelector('.title').textContent);
    const url = encodeURIComponent(parent.querySelector('a').href);
    
    shareToSocial({
      title: title,
      socialNetwork: socialNetwork,
      url: url
    });
    
    item.closest('.social-icons').classList.remove('active');
  }
});

function shareToSocial(params) {
  const shareUrls = {
    telegram: `https://t.me/share/url?url=${params.url}&text=${params.title}`,
    vk: `https://vk.com/share.php?url=${params.url}&title=${params.title}&noparse=true`,
    whatsapp: `https://wa.me/?text=${params.title}%20${params.url}`
  };

  if (shareUrls[params.socialNetwork]) {
    window.open(
      shareUrls[params.socialNetwork],
      '_blank',
      'width=600,height=500,menubar=no,toolbar=no,location=no,status=no'
    );
  }
}

 }

initFavoritesAndCompare();

function onAjaxSuccess() {
  const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  const compares = JSON.parse(localStorage.getItem('compares')) || [];
  updateAll(favorites, compares);
    initFavoritesAndCompare();
}




if (window.location.pathname.includes('/favorites')) {
    // Действия для страницы избранного
    loadFavoritesFromLocalStorage();
}

function loadFavoritesFromLocalStorage() {
    // Получаем избранное из localStorage
    const favorites = JSON.parse(localStorage.getItem('favorites')) || [];

    if (favorites.length === 0) {
        // Если избранное пустое
        document.getElementById('cars-list').innerHTML = `
            <div class="alert alert-info">
                В избранном пока нет автомобилей
            </div>
        `;
        return;
    }
    
    // Отправляем запрос на сервер для получения данных
    fetch('/api/favorites/get', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
             },
        body: JSON.stringify({ ids: favorites })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // Отображаем автомобили
            // document.getElementById('cars-list').innerHTML = data.html;
     document.getElementById('cars-list').innerHTML = '';
  
document.getElementById('cars-list').innerHTML = data.html;
initFavoritesAndCompare();
          
        } else {
            showErrorMessage();
        }
       })
    .catch(error => {
        console.error('Error:', error);
        showErrorMessage();
    });
}


function showErrorMessage() {
    document.getElementById('favorites-container').innerHTML = `
        <div class="alert alert-danger">
            Произошла ошибка при загрузке избранного
        </div>
    `;
}
   



const openFavorite = document.querySelector('.count-favorite');
const openComparison = document.querySelector('.count-compare');
if (openFavorite) {
  

openFavorite.addEventListener('click',()=>{
   window.location.href = '/favorites';

});
openComparison.addEventListener('click',()=>{
   window.location.href = '/comparison';

});

}







if (window.location.pathname.includes('/comparison')) {
    loadComparisonFromLocalStorage();
}

function loadComparisonFromLocalStorage() {
    const favorites = JSON.parse(localStorage.getItem('compares')) || [];
     if (favorites.length === 0) {
      const compareContainer =   document.querySelector('.compare-cars');
        compareContainer.innerHTML = `
            <div class="alert alert-info">
                Добавьте автомобили для сравнения
            </div>
        `;
        return;
    }
    
    fetch('/api/comparison/get', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
             },
        body: JSON.stringify({ ids: favorites })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            document.querySelector('.compare-cars').innerHTML = '';
  document.querySelector('.compare-cars').innerHTML = data.html;
// initFavoritesAndCompare();
       const swiperCompare = document.querySelector('.compare-swiper'); 
            const swiperComp = new Swiper(swiperCompare, {
            loop: true,
            slidesPerView: 4,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-comp',
                prevEl: '.swiper-button-prev-comp',
            },
                                     breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
        
    },
      768: {
      slidesPerView: 4,
    },
  },
        });
       


        } else {
            showErrorMessage();
        }
       })
    .catch(error => {
        console.error('Error:', error);
        showErrorMessage();
    });
}




const compareContainer = document.querySelector('.compare-cars');

if (compareContainer) {
  
  document.querySelector('.compare-cars').addEventListener('click', function(event) {

  if (event.target.classList.contains('only-difference') || 
      event.target.closest('.only-difference')) {
    showDifferences();
    // highlightDifferences();
  }

if (event.target.classList.contains('trash') || 
      event.target.closest('.trash')) {
      const carId = event.target.closest('.trash').dataset.id;
      const container = event.target.closest('.swiper-slide');
      removeFromCompare(carId);
      container.remove();

}
});

function removeFromCompare(carId) {

    const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  const compares = JSON.parse(localStorage.getItem('compares')) || [];

  
  const updatedCompares = compares.filter(id => id !== carId);
   localStorage.setItem('compares', JSON.stringify(updatedCompares));
     updateAll(favorites,compares);
}



const originalLists = new Map();
const originalStates = new Map();

function showDifferences() {
  const rawElements = document.querySelectorAll('.raw ul');
  
  // Если уже в режиме "только различия" - восстанавливаем
  if (originalStates.size > 0) {
    rawElements.forEach((ul, index) => {
      if (originalStates.has(index)) {
        // Удаляем класс hidden у всех элементов
        ul.querySelectorAll('li.common-item-hidden').forEach(li => {
          li.classList.remove('common-item-hidden');
        });
      }
    });
    
    originalStates.clear();
    return;
  }

  // Сохраняем текущее состояние (какие элементы были скрыты)
  rawElements.forEach((ul, index) => {
    const hiddenItems = Array.from(ul.querySelectorAll('li.common-item-hidden'));
    originalStates.set(index, hiddenItems);
  });

  // Собираем все элементы
  const allListsItems = Array.from(rawElements).map(ul => 
    Array.from(ul.querySelectorAll('li:not(.common-item-hidden)')).map(li => li.textContent.trim())
  );

  // Находим общие элементы
  const commonItems = allListsItems.reduce((common, currentList) => 
    common.filter(item => currentList.includes(item))
  );

  // Помечаем общие элементы
  rawElements.forEach(ul => {
    const items = ul.querySelectorAll('li:not(.common-item-hidden)');
    items.forEach(li => {
      if (commonItems.includes(li.textContent.trim())) {
        li.classList.add('common-item-hidden');
      }
    });
  });
}
}


window.showModalForm = function(params) {
    const modal = document.querySelector('.modal');
    const bg = document.querySelector('.modal-bg');
    const title =  document.querySelector('.modal__form-title');
    const info =  document.querySelector('.modal__form-info');
    const close = document.querySelector('.close');
    const message = params.message;
    const type = params.type;
    title.innerHTML = params.title;
    info.innerHTML = params.info;
    document.body.style.overflow = 'hidden';
    modal.classList.add('active');
    bg.classList.add('active');
  bg.addEventListener('click',function(){
    modal.classList.remove('active');
    bg.classList.remove('active');
    document.body.style.overflow = '';
  });
   close.addEventListener('click',function(){
    modal.classList.remove('active');
    bg.classList.remove('active');
    document.body.style.overflow = '';
  });
}



async function sendToComagic(formData, formElement) {
  if (!isComagicAvailable()) {
    console.log('Comagic не доступен, пропускаем отправку');
    return true; // Возвращаем true, чтобы не прерывать основной поток
  }

  const comagicData = {
    phone: formData.get('phone'),
    name: formData.get('name') || '',
    form_name: formElement.getAttribute('data-type') || 'Форма с сайта',
    message: Array.from(formData.entries())
      .filter(([key]) => !['phone', 'name', '_token'].includes(key))
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n')
  };

  return new Promise((resolve) => {
    window.Comagic.addOfflineRequest(comagicData, function(o) {
      if (o instanceof XMLHttpRequest) {
        o = JSON.parse(o.response);
      }
      resolve(o.success);
    });
  });
}



// Модифицированная handleFormSubmit
async function handleFormSubmit(e) {

  e.preventDefault();
  
  const form = e.target;
  const phoneInput = form.querySelector('input[name="phone"]');

  const submitButton  = form.querySelector('button');
  const checkbox = form.querySelector('input[name="politic"]');
  const checkMark = form.querySelector('.checkmark-check');

  const phone = phoneInput.value;




  phoneInput.style.border = '1px solid #e8e8e8';

  if (!validatePhone(phone)) {
    if (phoneInput.errorTimeout) {
      clearTimeout(phoneInput.errorTimeout);
    }
    




    phoneInput.errorTimeout = setTimeout(() => {
      phoneInput.style.border = '1px solid red';
    }, 300);
    return false;
  }


if (!checkbox.checked) {
  checkMark.classList.add('highlight-animation')
  checkMark.style.border = '1px solid red';

  setTimeout(()=> {
 checkMark.classList.remove('highlight-animation')
  },1000);

     return false;
}


    submitButton.disabled = true;
    submitButton.innerHTML = 'Отправка';

  const type = form.getAttribute('data-type') || '';
  const formData = new FormData(form);
  formData.append('type', type);

  try {
    // Создаем массив промисов
    const promises = [
      fetch("/sendform", {
        method: "POST",
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        }
      })
    ];
    console.log(document.querySelector('meta[name="csrf-token"]').content);
    // Добавляем Comagic только если он доступен
    if (isComagicAvailable()) {
      promises.push(sendToComagic(formData, form));
    }

    const [serverResponse, comagicResponse] = await Promise.all(promises);
    
    if (!serverResponse.ok) throw new Error("Ошибка сервера");
    
    const result = await serverResponse.json();
    form.reset();
    
    // Учитываем что comagicResponse может быть undefined
    const successMessage = comagicResponse === false 
      ? 'Заявка принята, но возникла проблема с системой уведомлений. Мы вам перезвоним.'
      : 'Спасибо! Заявка отправлена. В ближайшее время с Вами свяжется менеджер.';
    
    showMessage(successMessage);
if (typeof ym !== 'undefined') {
  ym(96709111,'reachGoal','form_send')
}


  } catch (error) {
    console.error("Ошибка:", error);
    showMessage('Ошибка отправки формы! Пожалуйста, попробуйте позже.');
  } finally {
    // В любом случае разблокируем кнопку и убираем прелоадер
    submitButton.disabled = false;
    submitButton.textContent = 'Отправить';
  }
}

// Инициализация форм


function showMessage(message, type = 'success') {
  // Создаем элементы
  const messageContainer = document.createElement('div');
  const messageTitle = document.createElement('div');
  const messageBg = document.createElement('div');
  
  // Добавляем классы
  messageContainer.className = `show__message show__message--${type}`;
  messageTitle.className = 'show__message-title';
  messageBg.className = 'show__message-bg';
  
  // Устанавливаем текст
  messageTitle.textContent = message;
  
  // Собираем структуру
  messageContainer.appendChild(messageTitle);
  
  // Добавляем в body
  document.body.appendChild(messageContainer);
  document.body.appendChild(messageBg);
  
  // Автоматическое закрытие через 5 секунд
//   setTimeout(() => {
//     messageContainer.remove();
//     messageBg.remove();
//   }, 5000);
  
   


  // Закрытие по клику на фон
  messageBg.addEventListener('click', () => {
    messageContainer.remove();
    messageBg.remove();
  });
}

const forms = document.querySelectorAll('.sendform');
if (forms) {
  forms.forEach(form => {
    form.addEventListener("submit", handleFormSubmit);
  });
}

const elements = document.querySelectorAll('input[name="phone"]');

if (elements.length) {



const maskOptions = {
  mask: '+{7} (#00) 000-00-00',
  placeholderChar: '_',
 lazy: false,
 definitions: {
    '#': /[49]/
  },
 
};
let mask = '';
for (let i = 0; i < elements.length; i++) {
  // Инициализация маски для элемента
  const mask = IMask(elements[i], maskOptions);
  
  // Добавление слушателя события focus
  elements[i].addEventListener('focus', function() {

    // Дополнительные действия при фокусе
    // Например, можно выделить поле ввода:
//  mask.updateCursor(7);

  });
}
// const mask = IMask(element, maskOptions);
}
function validatePhone(phone) {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length === 11 && (cleaned[0] === '7' || cleaned[0] === '8');
}

function isComagicAvailable() {
  return typeof window.Comagic !== 'undefined' && 
         typeof window.Comagic.addOfflineRequest === 'function';
}



const hamburger = document.querySelector('.hamburger');

hamburger.addEventListener('click',()=>{
const mobileMenu = document.querySelector('.header-menu');
mobileMenu.classList.toggle('active');
hamburger.classList.toggle('active');


});


const frontBrands = document.querySelector('.brands');
if (frontBrands) {
    const but = document.querySelector('.mobile-show-more');
    but.addEventListener('click',()=>{
    frontBrands.style.height = 'auto';
     but.remove();


    });

}


const showFooterBrands = document.querySelector('.show-all-footer-brands');
const footerBrands = document.querySelector('.footer__brands');
showFooterBrands.addEventListener('click',()=>{
footerBrands.style.height = 'auto';
showFooterBrands.remove();


});

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Плавная прокрутка
  });
}

function toggleBackToTopBtn() {
  const btn = document.querySelector('.back-to-top');
  if (window.scrollY > 300) {
    btn.classList.add('show');
  } else {
    btn.classList.remove('show');
  }
}
const debouncedToggle = debounce(toggleBackToTopBtn, 200);



function toggleHamburger() {
  const btn = document.querySelector('.hamburger');
  if (window.scrollY > 50) {
    btn.classList.add('show');
  } else {
    btn.classList.remove('show');
  }
}
const debouncedToggleHamburger = debounce(toggleHamburger, 200);
      if (window.innerWidth <= 768 ) {
  toggleHamburger();

window.addEventListener('scroll', debouncedToggleHamburger);


      }




document.querySelector('.back-to-top').addEventListener('click', scrollToTop);
window.addEventListener('scroll', debouncedToggle);

toggleBackToTopBtn();

const showTopAlphabetBrands = document.querySelector('.show__all-b');
const topABrands = document.querySelector('.top-alphabet');
if (showTopAlphabetBrands) {
    showTopAlphabetBrands.addEventListener('click',()=>{
      topABrands.classList.toggle('active');
      const text =  showTopAlphabetBrands.textContent.trim();
         showTopAlphabetBrands.textContent = text.includes('Показать все') 
        ? text.replace('Показать все', 'Скрыть') 
        : text.replace('Скрыть', 'Показать все');
    });
}


  const tabs = document.querySelectorAll('.front__tabs .tab');
  const tabItems = document.querySelectorAll('.front__tabs-item');
  if (tabs.length > 0) {
    

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      // Удаляем active
      tabs.forEach(t => t.classList.remove('active'));
      tabItems.forEach(item => {
        item.classList.remove('active');
        item.style.opacity = 0;
      });
      
      // Добавляем active с анимацией
      tab.classList.add('active');
      tabItems[index].classList.add('active');
      setTimeout(() => {
        tabItems[index].style.opacity = 1;
      }, 10);
    });
  });
  }

  if (!document.cookie.includes('cookies_accepted=true')) {
    // Создаем элемент плашки
    const cookieBanner = document.createElement('div');
    cookieBanner.id = 'cookie-banner';
    cookieBanner.innerHTML = `
      <div class="cookie-content">
        <p>Мы используем cookies для улучшения работы сайта. Оставаясь на сайте, вы соглашаетесь с <a href="/politic" target="_blank">Политикой конфиденциальности</a>.</p>
        <button id="accept-cookies">Принять</button>
      </div>
    `;
    
    // Добавляем стили
    const style = document.createElement('style');

    

    document.body.appendChild(cookieBanner);
    
    // Обработчик кнопки
    document.getElementById('accept-cookies').addEventListener('click', function() {
      // Устанавливаем cookie на 1 год
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      document.cookie = `cookies_accepted=true; expires=${date.toUTCString()}; path=/`;
      
      // Скрываем плашку с анимацией
      cookieBanner.style.transition = 'transform 0.3s ease';
      cookieBanner.style.transform = 'translateY(100%)';
      
      // Удаляем плашку после анимации
      setTimeout(() => {
        cookieBanner.remove();
        style.remove();
      }, 300);
    });
  }


const videos = document.querySelectorAll('.online');
if (videos.length > 0) {
    videos.forEach((ctx)=> {
        ctx.addEventListener('click',()=>{
          const src = ctx.dataset.src;
     
          // if (container) {
          //     container.remove();
          // }
          const data = `<div class="video-container">
            <div class="wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#fff" class="bi bi-x-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
</svg>
        <video controls width="100%" autoplay muted playsinline>
            <source src="${src}" type="video/mp4">
            Ваш браузер не поддерживает видео.
        </video>
        </div><div class="video-bg"></div></div>`;
      document.body.insertAdjacentHTML('beforeend',data);
           const container = document.querySelector('.video-container');
        const close = document.querySelector('.video-container svg');
        const bg = document.querySelector('.video-bg');
        console.log(close)
          //  const container = document.querySelector('.video-container');
        close.addEventListener('click',()=> {
        
            container.remove();
         
        })
        bg.addEventListener('click',()=> {
               container.remove();
          
        });

        })
    });
}


if (window.innerWidth <= 768) {
  const models = document.querySelectorAll('.brand__models a');

  if (models.length > 0) {
    const linksArray = [];
 models.forEach((link, index) => {
  const linkObject = {
    value: link.getAttribute('href'),
    label: link.getAttribute('title'),
    id: index + 1 // можно убрать, если не нужен
  };
  
  linksArray.push(linkObject);
});


     const selectElement = document.createElement('select');
        selectElement.id = 'model-select'; 
      const choices = [
                { value: '', label: 'Выберите модель', selected: true,disabled:true}
            ].concat(
                linksArray.map(model => ({
                    value: model.value,
                    label: model.label
                }))
            );

  const choicesArr = new Choices(selectElement, {
    items:choices,
    searchEnabled: true,
    searchChoices: true,
  });

            choicesArr.setChoices(choices, 'value', 'label', true);





const container = document.querySelector('.brand__models');
container.appendChild(selectElement);

selectElement.addEventListener('change', function(){

let href = this.value;
window.open(href,'_self');
});

  }
}
const searchForm = document.querySelector('.search-form');

if (searchForm) {
  

searchForm.addEventListener('submit',  (e) => {
      e.preventDefault();
        debounce(async () => {
  const searchInput = searchForm.querySelector('input[name="search"]');
        const searchValue = searchInput.value.trim();
   if (!/^\d+$/.test(searchValue)) {
            document.getElementById('cars-list').innerHTML = `
                <div class="alert alert-warning">
                    Введите корректный № автомобиля (только цифры)
                </div>
            `;
            return;
        }

        const loader = document.querySelector('.loading');
        if (loader) loader.style.display = 'flex';
        
        try {
            const response = await fetch('/api/cars/search-by-id', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: parseInt(searchValue)
                })
            });
            
            const data = await response.json();
            
            if (!response.ok) {
                throw new Error(data.message || 'Ошибка при поиске');
            }
            
            document.getElementById('cars-list').innerHTML = data.html;
            document.querySelector('.pagination-container').innerHTML = '';
            
        } catch (error) {
            console.error('Search error:', error);
            document.getElementById('cars-list').innerHTML = `
                <div class="alert alert-danger">
                    Ошибка: ${error.message}
                </div>
            `;
        } finally {
            if (loader) loader.style.display = 'none';
        }



   }, 300)();
});
}   





});
